import RolesPage from './components/RolesPage';

export default RolesPage;
